import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ViewChildren, QueryList } from '@angular/core';
import * as _ from "lodash";

import * as ent from '../entities/index'

//base
import { BaseDropdownComponent } from '../baseclasses/BaseDropdown.component';
import { BaseControlGroupComponent } from '../baseclasses/BaseControlGroup.component';
import { BaseEditComponent } from '../baseclasses/BaseEdit.component';
import { BaseLineItemEntity } from '../baseclasses/BaseLineItemEntity';

export abstract class BaseGridComponent implements OnInit {
    ngOnInit() { };

    @ViewChildren(BaseEditComponent) editors: QueryList<BaseEditComponent>;

    public loadDropDowns() {
        if (this.editors) {
            var editors = this.editors.toArray();

            for (var editor of editors) {
                editor.loadDropDowns();
            }
        }
    }

    public addLineItem(lineItem: BaseLineItemEntity, lineItems: BaseLineItemEntity[]): BaseLineItemEntity[] {
        if (!lineItems) { lineItems = [] }

        //2020-05-17: For AR-537: remove reliance on these "dummy" IDs
        //2021-03-05: For AR-756: re-add reliance on these "dummy" IDs
        let id = lineItem.ID ? lineItem.ID : lineItem.DummyID;
        if (!id) {

            let maxDummyID: number;
            if (lineItems.length > 0) {
                maxDummyID = _.maxBy(lineItems, x => x.DummyID ? x.DummyID : 0).DummyID;
            }
            if (!maxDummyID) {
                maxDummyID = 0;
            }

            lineItem.DummyID = maxDummyID + 1;

            lineItems = [...lineItems, lineItem];
        }
        return lineItems;
    }

    getCellData(row: any, col: any): any {
        const nestedProperties: string[] = col.field.split('.');
        let value: any = row;
        for (const prop of nestedProperties) {
            value = value[prop];
        }

        return value;
    }

    getColumnWidth(col: any) {
        if (!col['width']) {
            return '15em'
        }
        else {
            return col['width'];
        }

    }


}

export default BaseGridComponent;